import { Http } from "../../../utils/types"
import { SignatureOperation } from "../enums/signatureOperation";

export interface BodyUrl {
    bucketName: string,
    key: string | {
        Key: string;
    }[],
    operation: SignatureOperation,
    type?: string
}

export const sharedService = (client: Http) => ({
    getUrlSignature: async ({ body }:{ body:BodyUrl}) => {
        const response: Response = await client.post(`access-signed-url/generate`, body);
        return response
    }
})
